import React, { useEffect, useState } from 'react'
import { useGetMailSettingQuery, useUpdateMailSettingMutation } from '../../../Store/Apis/toolsApi';
import toast from 'react-hot-toast';

const MailSettings = () => {
  const [formData, setFormData] = useState({
    mailHost: '',
    mailPort: '',
    mailUsername: '',
    mailPassword: '',
    mailFromAddress: '',
    mailFromName: '',
    enableForget: false,
  });

  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    setFormData({ ...formData, enableForget: e.target.checked });
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};
    if (!formData.mailHost) newErrors.mailHost = 'Mail Host is required';
    if (!formData.mailPort) newErrors.mailPort = 'Mail Port is required';
    if (!formData.mailUsername) newErrors.mailUsername = 'Mail Username is required';
    if (!formData.mailPassword) newErrors.mailPassword = 'Mail Password is required';
    if (!formData.mailFromAddress) newErrors.mailFromAddress = 'Mail From Address is required';
    if (!formData.mailFromName) newErrors.mailFromName = 'Mail From Name is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const mailSetting = useGetMailSettingQuery()
  
  useEffect(()=>{
    if(mailSetting.isSuccess && mailSetting.data.data.length > 0){
      setFormData({
        mailHost: mailSetting.data.data[0].mailHost,
        mailPort: mailSetting.data.data[0].mailPort,
        mailUsername: mailSetting.data.data[0].mailUsername,
        mailPassword: mailSetting.data.data[0].mailPassword,
        mailFromAddress: mailSetting.data.data[0].mailFromAddress,
        mailFromName: mailSetting.data.data[0].mailFromName,
        enableForget: mailSetting.data.data[0].enablePasswordRecovery,
      })
    }
  }, [mailSetting])

  
  // Handle form submission
  const [updateMailSetting] = useUpdateMailSettingMutation()
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      updateMailSetting({
        id                    : 1,
        mailHost              : formData.mailHost,
        mailPort              : formData.mailPort,
        mailUsername          : formData.mailUsername,
        mailPassword          : formData.mailPassword,
        mailFromAddress       : formData.mailFromAddress,
        mailFromName          : formData.mailFromName,
        enablePasswordRecovery: formData.enableForget
      }).then((res)=>{
        if (res?.data?.status === 200) {
          toast.success(res?.data?.message, { duration: 7000 });
        } else {
          toast.error(res?.data?.message, { duration: 7000 })
        }
      })
      // Perform further actions like sending data to the server
    }
  };

  return (
    <>
      <h5 className="fw-500 text-white mb-3">Mail Settings</h5>
      <div className='card mb-4'>
        <div className="card-body p-4">
          <form onSubmit={handleSubmit}>
            <div className="row gy-3 mb-4">
              {/* Mail Host */}
              <div className="col-md-6">
                <label>MAIL HOST *</label>
                <input
                  type="text"
                  className="form-control"
                  name="mailHost"
                  value={formData.mailHost}
                  onChange={handleChange}
                />
                {errors.mailHost && <small className="text-danger">{errors.mailHost}</small>}
              </div>

              {/* Mail Port */}
              <div className="col-md-6">
                <label>MAIL PORT *</label>
                <input
                  type="text"
                  className="form-control"
                  name="mailPort"
                  value={formData.mailPort}
                  onChange={handleChange}
                />
                {errors.mailPort && <small className="text-danger">{errors.mailPort}</small>}
              </div>

              {/* Mail Username */}
              <div className="col-md-6">
                <label>MAIL USERNAME *</label>
                <input
                  type="text"
                  className="form-control"
                  name="mailUsername"
                  value={formData.mailUsername}
                  onChange={handleChange}
                />
                {errors.mailUsername && <small className="text-danger">{errors.mailUsername}</small>}
              </div>

              {/* Mail Password */}
              <div className="col-md-6">
                <label>MAIL PASSWORD *</label>
                <input
                  type="password"
                  className="form-control"
                  name="mailPassword"
                  value={formData.mailPassword}
                  onChange={handleChange}
                />
                {errors.mailPassword && <small className="text-danger">{errors.mailPassword}</small>}
              </div>

              {/* Mail From Address */}
              <div className="col-md-6">
                <label>MAIL FROM ADDRESS *</label>
                <input
                  type="text"
                  className="form-control"
                  name="mailFromAddress"
                  value={formData.mailFromAddress}
                  onChange={handleChange}
                />
                {errors.mailFromAddress && <small className="text-danger">{errors.mailFromAddress}</small>}
              </div>

              {/* Mail From Name */}
              <div className="col-md-6">
                <label>MAIL FROM NAME *</label>
                <input
                  type="text"
                  className="form-control"
                  name="mailFromName"
                  value={formData.mailFromName}
                  onChange={handleChange}
                />
                {errors.mailFromName && <small className="text-danger">{errors.mailFromName}</small>}
              </div>

              {/* Enable Password Recovery */}
              <div className="col-md-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enableForget"
                    checked={formData.enableForget}
                    onChange={handleCheckboxChange}
                  />
                  <label className="form-check-label" htmlFor="enableForget">
                    Enable Password Recovery (Forget Password Section)
                  </label>
                </div>
              </div>
            </div>
            {/* Submit Button */}
            <div className="text-center">
                <button type="submit" className="btn btn-primary">
                  Save Settings
                </button>
              </div>
          </form>
        </div>
      </div> 
    </>    
  )
}

export default MailSettings